import { motion, useReducedMotion } from 'framer-motion';
import { pageTransitionProps } from 'constants/animationProps';

const PageTransition = ({ children }) => {
  const reduced = useReducedMotion();

  return (
    <motion.div
      initial={reduced ? false : pageTransitionProps.initial}
      animate={pageTransitionProps.animate}
      transition={reduced ? { duration: 0 } : pageTransitionProps.transition}
      style={{ width: '100%', height: '100%' }}
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;
